export default __webpack_public_path__ + "static/media/Anna.5d8db4ac.jpg";